import { type Context, createContext } from 'react';
import type { ChartValues } from '@/types/chart';

export const VisualMenuContext = createContext(undefined) as unknown as Context<
  (data: ChartValues[][] | ChartValues[]) => void
>;
